import * as Constants from '../constants/point';

export const rescanPoints = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_POINT_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/points-history/`,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_POINT_SUCCESS, payload: res.data['points-history'] });
        resolve(res.data['points-history']);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_POINT_FAILED, payload: error });
        reject(error);
      });
  });

export const createPointsHistory = ($http, ENV, userId, activityId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_POINT_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/points-history/user-activities/${activityId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.UPDATE_POINT_SUCCESS,
          payload: res.data['points-history-activities'],
        });
        resolve(res.data['points-history-activities']);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_POINT_FAILED, payload: error });
        reject(error);
      });
  });
